import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Magacin } from './../magacin/magacin';

@Component({
  selector: 'yt-magacin-modal-update',
  templateUrl: './magacin-modal-update.component.html'
})
export class MagacinModalUpdateComponent extends BaseModalUpdateComponent<Magacin> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Magacin>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
